// React/finance-app/src/components/KeyValueGrid.jsx
import React from 'react';

const KeyValueGrid = ({ data }) => {
  if (!data || typeof data !== 'object') return null;
  const entries = Object.entries(data);
  if (entries.length === 0) return <div className="text-muted">No data</div>;
  return (
    <div className="row g-2">
      {entries.map(([k, v]) => (
        <div className="col-md-4" key={k}>
          <div className="border rounded p-2 bg-light">
            <div className="text-muted small">{k}</div>
            <div className="fw-semibold">{String(v)}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeyValueGrid;
